import { CURRENT_ITEM_OUTPUT_ID } from "../../../../../utils/constants";
import type { LoopScope } from "../../../../../stores/automation/looping.store";
import type { ValueConfig_V } from "@smartsuite/automation-engine-api";

export const currentItemOutputsRefPill = (
  looping: LoopScope,
): ValueConfig_V[] => {
  if (looping.source?.oneofKind === "outputReference") {
    switch (looping.source.outputReference.source.oneofKind) {
      case "actionReference":
        return [
          {
            value: {
              oneofKind: "reference",
              reference: {
                source: {
                  oneofKind: "actionReference",
                  actionReference:
                    looping.source.outputReference.source.actionReference,
                },
                outputId: CURRENT_ITEM_OUTPUT_ID,
              },
            } as const,
          },
        ];
      case "triggerReference":
        return [
          {
            value: {
              oneofKind: "reference",
              reference: {
                source: {
                  oneofKind: "triggerReference",
                  triggerReference:
                    looping.source.outputReference.source.triggerReference,
                },
                outputId: CURRENT_ITEM_OUTPUT_ID,
              },
            } as const,
          },
        ];
      case "loopItem":
      default:
        return [];
    }
  }
  return [];
};
